/**
 * The `locale` cookie (DEN-99 §5): not httpOnly, SameSite=Lax, Path=/, ~1 year.
 * The client owns it end to end — the server never parses it. It is the
 * bootstrap value for the anonymous visitor.
 */
import { isSupportedLocale, type SupportedLocale } from './config';

const COOKIE = 'locale';
const MAX_AGE = 60 * 60 * 24 * 365;

export function readLocaleCookie(): SupportedLocale | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const hit = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${COOKIE}=`));
  const value = hit ? decodeURIComponent(hit.slice(COOKIE.length + 1)) : null;
  return isSupportedLocale(value) ? value : null;
}

export function writeLocaleCookie(locale: string): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie =
    `${COOKIE}=${encodeURIComponent(locale)}; Max-Age=${MAX_AGE}; ` +
    `Path=/; SameSite=Lax`;
}
